import { Api } from '@/services/AxiosService'

const actions = {
  async fetchFlatsFilterParams(ctx) {
    const { data } = await Api.fetchFlatsFilterParams()
    ctx.commit('setFlatsFilterParams', data)
    ctx.commit('setDefaultFlatFilter', data)
  },
}
const mutations = {
  setFlatsFilterParams(state, data) {
    state.flatsFilterParams = data
  },
  setShowFilter(state, isShow){
    state.showFilter = isShow
  },
}
const getters = {
  getFlatsFilterParams(state) {
    return state.flatsFilterParams
  },
  getShowFilter(state){
    return state.showFilter
  }
}

const state = {
  flatsFilterParams: null,
  showFilter: false,
}

export default {
  state,
  getters,
  mutations,
  actions,
}
